import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '@tcc-mono/shared/app-config';
import { BaseService, Response } from '@tcc-mono/shared/data-access';
import { SalesInvoice } from '@tcc-mono/vandijk/shared/data-access/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SalesInvoiceService extends BaseService<SalesInvoice> {
  constructor(
    _http: HttpClient,
    @Inject(APP_CONFIG) appConfig: IAppConfig
  ) {
    super(_http, appConfig);
    this.path = 'api/sales_invoice'
  }

  public sendToExact = (id: number): Observable<Response<SalesInvoice>> => {
    return this._http.post<Response<SalesInvoice>>(`${this.getUrl(this.path)}/${id}/export/exact`, {});
  }

  public downloadPdf = (invoiceId: number): Observable<Blob> => {
    return this._http.get(
      `${this.getUrl(this.path)}/${invoiceId}/pdf`,
      {
        responseType: 'blob'
      }
    );
  }

  public sendEmail = (invoiceId: number): Observable<unknown> => {
    return this._http.post(`${this.getUrl(this.path)}/${invoiceId}/send_email`, {});
  }
}
